let onRateRefreshNeeded: ((teamId: string) => void) | undefined;

export function setAdminRateRefreshHandler(
  handler: ((teamId: string) => void) | undefined,
): void {
  onRateRefreshNeeded = handler;
}

export function notifyAdminRateRefreshNeeded(teamId: string): void {
  onRateRefreshNeeded?.(teamId);
}
